import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";

const Btn = styled(Button)`
  background-color: ${props => (props.outline ? "transparent" : props.color)};
  min-width: 317px;
  font-size: 1.0625rem;
  color: ${props => (props.outline ? props.color : "#fff")};
  font-weight: bold;
  border: ${props => (props.outline ? "2px solid " + props.color : "none")};
  border-radius: 0.5rem;
  outline-style: none;
  transition: 0.5s opacity;
  &:hover {
    opacity: ${props => (props.outline ? "1" : ".85")};
    background-color: ${props => props.color};
    color: #fff;
    border-color: ${props => props.color};
  }
  &:focus {
    box-shadow: none;
  }
  &:not(:disabled):not(.disabled):active {
    background-color: ${props => props.color};
    opacity: 0.85;
    box-shadow: none;
  }
  &:not(:disabled):not(.disabled):active:focus {
    background-color: ${props => props.color};
    opacity: 0.85;
    box-shadow: none;
    border-color: ${props => props.color};
  }
  cursor: pointer;
  @media (max-width: 768px) {
    min-width: auto;
    width: 100%;
    font-size: 0.9rem;
  }
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${props => (props.outline ? "#fff" : props.color)};
  &:hover {
    background-color: ${props => props.color};
    color: #fff;
  }
`;

const stBtn = props => {
  return (
    <Btn
      block={props.block ? props.block : null}
      type={props.type ? props.type : "button"}
      form={props.form ? props.form : null}
      title={props.text}
      onKeyPress={props.onKeyPress ? props.onKeyPress : null}
      onClick={props.onClick}
      outline={props.outline ? props.outline : null}
      color={props.color}
      className={props.className ? props.className : ""}
    >
      {props.loading ? (
        <i
          style={{ fontSize: 20, marginTop: 5 }}
          className="fa fa-spinner fa-pulse fa-3x fa-fw"
        ></i>
      ) : (
        <Flex>
          {props.continue ? (
            <>
              <span
                style={{ color: props.outline ? "transparent" : props.color }}
                className={`mdi ${props.icon ? "mdi-" + props.icon : ""}`}
              />
              <span
                style={{
                  margin: "auto",
                  marginBottom: 0,
                  textDecoration: "none"
                }}
              >
                {props.text}
              </span>
              <span
                className={`mdi ${props.icon ? "mdi-" + props.icon : ""}`}
              />
            </>
          ) : (
            <>
              <span
                className={`mdi ${props.icon ? "mdi-" + props.icon : ""}`}
              />
              <span
                style={{
                  margin: "auto",
                  marginBottom: 0,
                  textDecoration: "none"
                }}
              >
                {props.text}
              </span>
              <span
                style={{ color: props.outline ? "transparent" : props.color }}
                className={`mdi ${props.icon ? "mdi-" + props.icon : ""}`}
              />
            </>
          )}
        </Flex>
      )}
    </Btn>
  );
};

export default stBtn;
